import {Asset} from "../../entities/Asset";
import {MaintenanceHistory} from "../../entities/MaintenanceHistory";
import {AlertingAction} from "../../entities/AlertingAction";
import {Reader} from "../../entities/Reader";
import {AssetService} from "../../services/AssetService";
import {MaintenanceHistoryService} from "../../services/MaintenanceHistoryService";
import {LocationService} from "../../services/LocationService";
import {AlertingActionService} from "../../services/AlertingActionService";
import {ReaderService} from "../../services/ReaderService";
import {PrintJobService} from "../../services/PrintJobService";
import {CustomFieldNameModel} from "./CustomFieldNameModel";
import {FileDataService} from "../../services/FileDataService";
import {NotificationService} from "../../services/NotificationService";
import {ApplicationSetting} from "../../entities/ApplicationSetting";
import {Template} from "../../entities/Template";
import {PrintJob} from "../../entities/PrintJob";
import {EditModel} from "./EditModel";
import { IEditMaintenanceHandler } from "../../libs/EditMaintenanceHandler/IEditMaintenanceHandler";
import { EditMaintenanceHandler_EditAsset } from "../../libs/EditMaintenanceHandler/EditMaintenanceHandler_EditAsset";
import { EditMaintenanceHandler_NewAsset } from "../../libs/EditMaintenanceHandler/EditMaintenanceHandler_NewAsset";

export class EditAssetModel extends EditModel<Asset> {
    $q:ng.IQService;
    entityId:number;
    imageHeight:number;
    imageWidth:number;
    b64String:string;
    allMaintenanceHistories:MaintenanceHistory[] = [];
    editedMaintenaceHistories:MaintenanceHistory[] = [];
    addedMaintenaceHistories:MaintenanceHistory[] = [];
    deletedMaintenanceHistories:MaintenanceHistory[] = [];
    parentAsset:Asset;
    allChildren:Asset[] = [];
    addedChildren:Asset[] = [];
    deletedChildren:Asset[] = [];
    selectedAsset:Asset;
    selectedMaintenance: MaintenanceHistory;
    enableAssetUnseen: boolean = false;
    locations:Location[];
    alertingActions:AlertingAction[];
    readers:Reader[];
    dateFormat: string;
    editMaintenanceHandler: IEditMaintenanceHandler;
    MAINTENANCE_NOMAINTENANCE = "No Maintenance";
    MAINTENANCE_PERIODIC = "Periodic";
    MAINTENANCE_SINGLEEVENT = "Single Event";
    disposalStatuses = ["In Service", "Disposed"];
    maintenanceMethods = [this.MAINTENANCE_NOMAINTENANCE, this.MAINTENANCE_PERIODIC,this.MAINTENANCE_SINGLEEVENT];
    customFieldNameValues: { [id: string] : string; } = {};
    listvalue1 = ["Excellent", "Good", "Fine", "Bad"];
    static $inject = ['$q', 'AssetService', 'MaintenanceHistoryService', 'LocationService', 'AlertingActionService',
        'ReaderService', 'PrintJobService', 'CustomFieldNameModel', 'FileDataService', 'NotificationService'];
    constructor($q:ng.IQService, public service:AssetService, public mhService:MaintenanceHistoryService,
        public locationService: LocationService, public alertingActionService: AlertingActionService,
                public readerService:ReaderService, public printjobService:PrintJobService,
                public cfnModel:CustomFieldNameModel,public fileDataService:FileDataService,
                public notifyService:NotificationService){
        super($q, service, Asset);
        this.dateFormat = ApplicationSetting.applicationSetting.dateFormat;
    }
    testPromise():ng.IPromise<string>{
        return this.$q.when<any>(true).then((data)=>{
            return this.$q.when<string>("Got here");
        });
    }
    getCustomFieldValue(cfnName:string):ng.IPromise<string>{
        var deferred = this.$q.defer<string>();
        this.cfnModel.connect().then(()=>{
            var displayVal = this.cfnModel.getCustomFieldValue(cfnName);
            deferred.resolve(displayVal);
        });
        return deferred.promise;
    }
    loadSecondaryData(entityId:number):ng.IPromise<boolean>{
        this.entityId = entityId;
        var imagePromise:ng.IPromise<string> = this.entity.fileDataID == null ?
          this.$q.when<string>(null) : this.fileDataService.get(this.entity.fileDataID);
        var parentAssetPromise:ng.IPromise<Asset> = this.entity.assetParentID == null ?
          this.$q.when<Asset>(null) : this.service.get(this.entity.assetParentID);
        return this.$q.all([this.service.getChildren(entityId),this.mhService.getByAsset(entityId),parentAssetPromise, imagePromise]).then((data)=>{
            this.allChildren = data[0];
            this.allMaintenanceHistories = data[1];            
            this.parentAsset = data[2];
            this.b64String = data[3];
            return this.$q.when<boolean>(true);
        })
        .catch((exc)=>{
            return this.$q.reject("got exc"+exc);
        });
    }
    loadEntityNameSerial(forceLoad:boolean = false):ng.IPromise<string>{
        var assetSerialPromise:ng.IPromise<string> = ApplicationSetting.applicationSetting.automaticallySerializeAssetName || forceLoad ?
            this.service.getCurrentAssetNameSerial() : this.$q.when<string>("");
        return assetSerialPromise;
    }
    loadData(entityId:number):ng.IPromise<boolean>{
        return super.loadData(entityId).then((ok) => {
            if (entityId !== null)
                this.editMaintenanceHandler = new EditMaintenanceHandler_EditAsset(this.$q, this.mhService, this.notifyService);
            else
                this.editMaintenanceHandler = new EditMaintenanceHandler_NewAsset(this.$q, this.mhService, this.notifyService);
        var deferred = this.$q.defer<boolean>();
        var locationPromise:ng.IPromise<any> = this.locationService.getAll();
        var alertingActionPromise:ng.IPromise<any> = this.alertingActionService.getAll();
        var readerPromise:ng.IPromise<any> = this.readerService.getAll();

        //var entityPromise:ng.IPromise<Asset> = null;

        var cfPromise: ng.IPromise<any> = this.cfnModel.connect();
        this.enableAssetUnseen = ApplicationSetting.applicationSetting.enableAssetUnseen;
        this.entityId = entityId;
        this.$q.all([locationPromise,alertingActionPromise, readerPromise, cfPromise]).then((data)=>{
          this.locations = data[0];
          data[1].unshift(new AlertingAction(null,""));
          this.alertingActions = data[1];
          this.readers = data[2];
          //this.entity = data[0];
          deferred.resolve(true);
        }).catch((exc)=>{
          alert("Got exception "+exc);
        });
        return deferred.promise;
      });
    }
    isHex(inputString:string):boolean{
        if(inputString == null || inputString.length == 0)
            return true;
        inputString = inputString.replace(' ', '');
        var re = /^[0-9a-f]+$/ig
        if(re.test(inputString)) {
            return true;
        } else {
            return false;
        }
    }
    verifyData():ng.IPromise<boolean>{
      if(this.entity.name == null || this.entity.name.length == 0){
        this.notifyService.notifyError("Name is required.");
        return this.$q.when<boolean>(false);
      }
        if (this.entity.vTagGpsDeviceID != null && this.entity.vTagGpsDeviceID.length > 0 && this.entity.vTagGpsDeviceID.length != 16){
          this.notifyService.notifyError("VTag GPS Device ID must be 16 characters if set.");
          return this.$q.when<boolean>(false);
      }
      if(!this.isHex(this.entity.vTagGpsDeviceID)){
          this.notifyService.notifyError("VTag GPS Device ID must be Hexadecimal.");
          return this.$q.when<boolean>(false);
      }
      if(this.entity.rfidTag != null && this.entity.rfidTag.length > 0 && !this.isHex(this.entity.rfidTag)){
        this.notifyService.notifyError("RFID Tag must be Hexadecimal.");
        return this.$q.when<boolean>(false);
      }
      if(this.entity.vTagID != null && this.entity.vTagID.length > 0 && !this.isHex(this.entity.vTagID)){
        this.notifyService.notifyError("V-Tag ID must be Hexadecimal.");
        return this.$q.when<boolean>(false);
        }
        if (this.entity.vTagID != null && this.entity.vTagID.length > 0 && !(this.entity.vTagID.length == 6 || this.entity.vTagID.length == 12)){
        this.notifyService.notifyError("V-Tag ID must be 6 or 12 digits.");
        return this.$q.when<boolean>(false);
      }
      var vtagPromise = this.entity.vTagID != null && this.entity.vTagID.length > 0 ? this.service.getByVTag(this.entity.vTagID) : this.$q.when<Asset>(null);
      var rfidPromise = this.entity.rfidTag != null && this.entity.rfidTag.length > 0 ? this.service.getByRfid(this.entity.rfidTag) : this.$q.when<Asset>(null);
      var gpsPromise = this.entity.vTagGpsDeviceID != null && this.entity.vTagGpsDeviceID.length > 0 ? this.service.getByGps(this.entity.vTagGpsDeviceID) : this.$q.when<Asset>(null);
      return this.$q.all([this.service.getByName(this.entity.name),vtagPromise, rfidPromise, gpsPromise]).then((data)=>{
        var nameAsset:Asset = data[0];
        var vtagAsset:Asset = data[1];
        var rfidAsset:Asset = data[2];
        var gpsAsset:Asset = data[3];
        if(nameAsset != null && nameAsset.id != this.entity.id)
        {
          this.notifyService.notifyError("Please choose a unique asset name.");
          return this.$q.when<boolean>(false);
        }
        else if(vtagAsset != null && vtagAsset.id != this.entity.id)
        {
          this.notifyService.notifyError("This V-Tag ID value is already associated with asset "+vtagAsset.name);
          return this.$q.when<boolean>(false);
        }
        else if(rfidAsset != null && rfidAsset.id != this.entity.id)
        {
            this.notifyService.notifyError("This RFID value is already associated with asset "+rfidAsset.name);
            return this.$q.when<boolean>(false);
        }
        else if(gpsAsset != null && gpsAsset.id != this.entity.id)
        {
            this.notifyService.notifyError("This VTag GPS Device ID value is already associated with asset "+gpsAsset.name);
            return this.$q.when<boolean>(false);
        }
        else
          return this.$q.when<boolean>(true);
      })
    }
    saveData():ng.IPromise<boolean>{
        var mainPromise:ng.IPromise<any> = null;
        //var deferred:ng.IDeferred<any> = this.$q.defer();
        return this.verifyData().then((ok)=>{
          //return this.getByName(this.entity.name)
          if(!ok)
            return this.$q.when<boolean>(false);
          if(this.entityId == null)
            mainPromise = this.service.insert(this.entity);
          else
            mainPromise = this.service.update(this.entity);
          var otherPromises:ng.IPromise<any>[] = [];          
          this.entity.assetChildCount = this.addedChildren.length;
          if(this.addedChildren.length > 0){
            var ids = $.map<Asset,number>(this.addedChildren, (item, index)=>item.id);
            otherPromises.push(this.service.associateChildren(ids, this.entityId));
          }
          if(this.deletedChildren.length > 0){
            var ids = $.map<Asset,number>(this.deletedChildren, (item, index)=>item.id);
            otherPromises.push(this.service.removeChildren(ids));
          }            
          return mainPromise.then((data)=>{
            if(this.entityId == null)
                  this.entityId = data;
              return this.editMaintenanceHandler.saveData(this.entityId).then(() => {
                return this.$q.all(otherPromises)
                  .then((data)=> {
                    return this.$q.when<boolean>(true);
                  })
                  .catch((err:any)=>{
                    return this.$q.reject("Got error in saving asset data:"+err);
                  });
              })
          })
        });
    }
    removeImage(){
      this.b64String = null;
      this.imageWidth = 0;
      this.imageHeight = 0;
      this.entity.fileDataID = null;
    }
    uploadImage(b64Data:string):ng.IPromise<number> {
      return this.fileDataService.insert(b64Data)
        .then((id)=> {
          this.b64String = b64Data;
          this.entity.fileDataID = id;
          return this.fileDataService.getImageSize(id);
        })
        .then((size)=>{
          var dataArr:string[] = size.split("x");
          this.imageWidth = parseInt(dataArr[0]);
          this.imageHeight = parseInt(dataArr[1]);
          return this.$q.when<number>(this.entity.fileDataID);
        })
        .catch((exc)=> {
          this.notifyService.notifyError("Error inserting file data: " + exc.message);
          return this.$q.when<number>(null);
        });
    }
    setNextMaintenance():void{
        var nextVal:Date = null;
        if(this.entity.maintenanceMethod == this.MAINTENANCE_PERIODIC){
            nextVal = this.entity.maintenanceStartDate;
        }
        else if(this.entity.maintenanceMethod == this.MAINTENANCE_SINGLEEVENT){
            nextVal = this.entity.maintenanceSingleDate;
        }
        this.entity.nextMaintenance = nextVal;
    }
    addMaintenance(item: MaintenanceHistory): void{
        this.editMaintenanceHandler.addMaintenance(item).then(() => {
        })
        .catch((exc) => {
            this.notifyService.notifyError("Error adding maintenance: " + exc.message);
            return this.$q.when<number>(null);
        });        
    }
    editMaintenance(item:MaintenanceHistory):void{
        this.editMaintenanceHandler.editMaintenance(item).then(() => {
        })
            .catch((exc) => {
                this.notifyService.notifyError("Error editing maintenance: " + exc.message);
                return this.$q.when<number>(null);
            });        
    }
    deleteMaintenance(item: MaintenanceHistory): void{
        this.editMaintenanceHandler.deleteMaintenance(item).then(() => {
        })
        .catch((exc) => {
            this.notifyService.notifyError("Error deleting maintenance: " + exc.message);
            return this.$q.when<number>(null);
        });        
    }
    addChild(item:Asset):boolean{
      var index = this.deletedChildren.indexOf(item);
      if(index != -1)
        this.deletedChildren.splice(index,1);
      for(var i=0;i<this.addedChildren.length;i++){
        if(this.addedChildren[i].id == item.id)
          return false;
      }
      this.addedChildren.push(item);
      return true;
    }
    deleteChild(item:Asset):void{
      if(item==this.selectedAsset)
        this.selectedAsset = null;
      var index = this.addedChildren.indexOf(item);
      if(index != -1)
        this.addedChildren.splice(index,1);
      else
        this.deletedChildren.push(item);
    }
    print(template:Template){
        var mainPromise:ng.IPromise<number> = null;
        if(this.entityId == null)
            mainPromise = this.service.insert(this.entity);
        else
            mainPromise = this.$q.when<number>(this.entityId);
        mainPromise.then((entityId)=>{
            if(this.entityId == null)
                this.entity.id=entityId;
            this.entityId = entityId;
            var printJob: PrintJob = new PrintJob(-1, this.entity.id, "Asset", template.id, template.useWithService);
            return this.printjobService.print(printJob)
                .then((newId) => {
                    return this.printjobService.get(newId).then((printJob) => {
                        this.entity.rfidTag = printJob.generatedRfid;
                        this.notifyService.notify("Print Job Scheduled Successfully.");
                    })
                });            
        })
        .catch((exc)=>{
            this.notifyService.notifyError("Printing Error",exc);
        });
    }
}
